<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <path
        fill="inherit"
        stroke="none"
        d="M5.62 20q-.7 0-1.16-.46T4 18.38V5.62q0-.7.46-1.16T5.62 4h6.4v1h-6.4q-.24 0-.43.2a.6.6 0 0 0-.19.42v12.76q0 .24.2.43.18.2.42.19h6.4v1zm10.84-4.46-.7-.72 2.32-2.32H9.19v-1h8.89l-2.32-2.32.7-.72L20 12z"
      />
    </svg>
  </span>
</template>
